"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _TicketStage = _interopRequireDefault(require("./TicketStage"));

var _immutable = require("immutable");

var TicketPipeline = (0, _immutable.Record)({
  pipelineId: undefined,
  portalId: undefined,
  objectType: undefined,
  displayOrder: -1,
  label: undefined,
  active: true,
  stages: (0, _immutable.List)(),
  default: false
}, 'TicketPipeline');

TicketPipeline.fromJS = function (json) {
  if (!json || (0, _typeof2.default)(json) !== 'object') {
    return json;
  }

  return TicketPipeline((0, _extends2.default)({}, json, {
    stages: json.stages ? (0, _immutable.List)(json.stages.map(_TicketStage.default.fromJS)) : (0, _immutable.List)()
  }));
};

var _default = TicketPipeline;
exports.default = _default;
module.exports = exports.default;